import { BsCashStack } from 'react-icons/bs';
import { BsCreditCard } from 'react-icons/bs';
import { TbDeviceMobileDollar } from 'react-icons/tb';

export const paymentModes = [
  { mode: 'Cash', icon: <BsCashStack /> },
  { mode: 'Debit Card', icon: <BsCreditCard /> },
  { mode: 'Mobile Money', icon: <TbDeviceMobileDollar /> },
];
